'use client';

import { cn } from '@/lib/utils';
import { InputHTMLAttributes, ReactNode, forwardRef } from 'react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import ErrorText from './ErrorText';

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
    required?: boolean;
    className?: string;
    register?: UseFormRegister<any>;
    error?: FieldError;
    label?: string | ReactNode;
}

const Checkbox = forwardRef<HTMLInputElement, CustomInputProps>((props, ref) => {
    const { className, required, label, id, register, error, ...inputProps } = props;

    return (
        <div className="relative">
            <div className={cn('flex items-center space-x-4', className)}>
                <input
                    {...register}
                    {...inputProps}
                    id={id}
                    ref={ref}
                    type="checkbox"
                    required={required}
                    className={cn(error && 'border-red-400')}
                />
                {label && (
                    <label className="text-p font-normal" htmlFor={id}>
                        {label}
                    </label>
                )}
            </div>
            {error && <ErrorText error={error} />}
        </div>
    );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
